import React from 'react';
import { motion } from 'framer-motion';
import { Star, Users, CheckCircle2 } from 'lucide-react';
import { Button } from './Button';
export function Hero() {
  const scrollToPricing = () => {
    const element = document.querySelector('#comprar');
    if (element) {
      const offset = 80;
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative pt-10 pb-8 md:pt-28 md:pb-24 overflow-hidden bg-brand-950 text-white" data-id="element-90">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0" data-id="element-91">
        <div className="absolute top-[-10%] right-[-5%] w-[300px] md:w-[500px] h-[300px] md:h-[500px] rounded-full bg-brand-800/30 blur-[100px]" data-id="element-92" />
        <div className="absolute bottom-[-10%] left-[-10%] w-[400px] md:w-[600px] h-[400px] md:h-[600px] rounded-full bg-accent-600/20 blur-[120px]" data-id="element-93" />
        <div className="absolute top-1/4 left-5 md:left-10 text-brand-800/20 text-7xl md:text-9xl font-bold select-none pointer-events-none rotate-12" data-id="element-94">
          한
        </div>
        <div className="absolute bottom-1/4 right-5 md:right-10 text-brand-800/20 text-7xl md:text-9xl font-bold select-none pointer-events-none -rotate-12" data-id="element-95">
          글
        </div>
      </div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-96">
        <div className="max-w-4xl mx-auto text-center flex flex-col items-center" data-id="element-97">
          {/* Badge */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-brand-800/50 border border-brand-700 text-brand-200 text-xs md:text-sm font-medium mb-3 md:mb-6" data-id="element-98">
            <span className="flex h-2 w-2 rounded-full bg-accent-500 animate-pulse" data-id="element-99"></span>
            <span data-id="element-100">🇰🇷 Para profes de 한국어 · Nuevo 2026</span>
          </motion.div>

          {/* Title */}
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight mb-2 md:mb-3 text-white" data-id="element-101">
            <span className="bg-gradient-to-r from-white via-accent-200 to-accent-500 bg-clip-text text-transparent" data-id="element-102">
              TODO TU AÑO DE COREANO RESUELTO
            </span>
            <span className="block text-xl sm:text-2xl md:text-3xl lg:text-4xl mt-1 md:mt-2 text-brand-200 font-semibold" data-id="element-103">
              (Sin Improvisar)
            </span>
          </motion.h1>

          {/* Product Image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative my-4 md:my-10 w-full max-w-[360px] sm:max-w-md md:max-w-xl lg:max-w-2xl cursor-pointer group" onClick={scrollToPricing} data-id="element-104">
            <div className="absolute inset-0 bg-gradient-to-tr from-accent-600/40 via-brand-600/30 to-accent-500/40 rounded-full blur-[80px] scale-90 opacity-60 group-hover:opacity-90 transition-opacity duration-500" data-id="element-105"></div>

            <div className="relative" data-id="element-106">
              <img src="https://cdn.magicpatterns.com/uploads/bKk2cKravpLPPMhkxjfP3D/a8f8d15f-8007-42d8-bdd0-7f121a3bb8d9.png" alt="Sistema Profe Coreano Pro" className="relative w-full h-auto object-contain transition-transform duration-700 group-hover:scale-[1.03] drop-shadow-[0_25px_50px_rgba(0,0,0,0.5)]" data-id="element-107" />

              {/* Floating badges - smaller on mobile */}
              <div className="absolute top-4 md:top-8 -left-1 md:-left-6 bg-white text-brand-950 px-2 py-2 md:px-4 md:py-3 rounded-lg md:rounded-xl shadow-2xl font-bold flex items-center gap-2 md:gap-3 transform -rotate-3 animate-bounce z-10" style={{
              animationDuration: '3s'
            }} data-id="element-108">
                <div className="bg-green-100 p-1 md:p-2 rounded-full" data-id="element-109">
                  <CheckCircle2 className="w-3 h-3 md:w-5 md:h-5 text-green-600" data-id="element-110" />
                </div>
                <div className="text-left" data-id="element-111">
                  <div className="text-[8px] md:text-[10px] text-brand-500 uppercase tracking-wider" data-id="element-112">
                    Listo para usar
                  </div>
                  <div className="text-[11px] md:text-sm" data-id="element-113">100% Práctico</div>
                </div>
              </div>

              <div className="absolute bottom-6 md:bottom-12 -right-1 md:-right-4 bg-brand-950 border border-brand-700 text-white px-2 py-2 md:px-4 md:py-3 rounded-lg md:rounded-xl shadow-2xl font-bold flex items-center gap-2 md:gap-3 transform rotate-3 z-10" data-id="element-114">
                <div className="bg-brand-800 p-1 md:p-2 rounded-full" data-id="element-115">
                  <Users className="w-3 h-3 md:w-5 md:h-5 text-brand-300" data-id="element-116" />
                </div>
                <div className="text-left" data-id="element-117">
                  <div className="text-[8px] md:text-[10px] text-brand-400 uppercase tracking-wider" data-id="element-118">
                    Comunidad
                  </div>
                  <div className="text-[11px] md:text-sm" data-id="element-119">+500 Profes</div>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Subtitle */}
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="text-base sm:text-lg md:text-2xl text-brand-100 mb-3 md:mb-4 font-medium leading-snug md:leading-relaxed max-w-3xl px-2" data-id="element-120">
            Sistema completo para planificar, estructurar y dar clases que
            enganchan alumnos
          </motion.p>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.4
        }} className="text-sm md:text-lg text-brand-300 mb-5 md:mb-8 leading-relaxed max-w-2xl px-2 hidden sm:block" data-id="element-121">
            El sistema más práctico para profesores de coreano que quieren dejar
            de improvisar y empezar a dar clases claras, dinámicas y
            profesionales desde el primer día.
          </motion.p>

          {/* CTA */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.5
        }} className="mb-5 md:mb-8 w-full sm:w-auto px-4 sm:px-0" data-id="element-122">
            <Button href="#comprar" size="lg" className="w-full sm:w-auto md:!px-10 md:!py-5 md:!text-xl" data-id="element-123">
              Acceder al Sistema PRO ahora
            </Button>
          </motion.div>

          {/* Social proof */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.6
        }} className="flex items-center justify-center gap-3 text-xs md:text-sm text-brand-200" data-id="element-124">
            <div className="flex -space-x-1.5 md:-space-x-2" data-id="element-125">
              {[1, 2, 3, 4, 5].map(i => <div key={i} className="w-6 h-6 md:w-8 md:h-8 rounded-full border-2 border-brand-950 bg-brand-800 flex items-center justify-center" data-id="element-126">
                  <Star className="w-3 h-3 md:w-4 md:h-4 text-yellow-400 fill-yellow-400" data-id="element-127" />
                </div>)}
            </div>
            <div className="flex flex-col items-start" data-id="element-128">
              <span className="font-bold text-white flex items-center gap-1" data-id="element-129">
                4.9/5{' '}
                <Star className="w-3 h-3 text-yellow-400 fill-yellow-400" data-id="element-130" />
              </span>
              <span data-id="element-131">Elegido por profes de coreano en LATAM</span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}